import * as SimplrErrors from '@asurion-core/typescript-utils/SimplrErrors';

export const SENTRY_ORG_SLUG = 'simplr';
export const defaultErrorPopupMessage = 'Sorry, there was an unexpected error';
export const defaultErrorRequestProblem = 'There was a problem with your request';
export const logoutPopupTimeout = 1000;

export const errorBoundaryDefaultText = 'Something went wrong. Please contact support.';

export const HANDLE_ERROR_INVALID_ARGS =
  'Either a custom message or an error message must be passed to ErrorService.handleError if not using popupOnly';

export const LOG_MESSAGE_INVALID_ARGS = 'Messages passed to ErrorService.logMessage must be of type string';

export const ERROR_MESSAGES = {
  DEFAULT: 'An error occurred while performing the action, please try again.',
  CASE_LOCKED: 'Case currently locked by another user',
  TICKET_LOCKED: 'This ticket is currently locked by another user. Please try again later.',
  PERSON_UNAVAILABLE: "This person isn't available right now.",
  SESSION_IS_INVALID: 'Your session is invalid. Please log off the platform and log back in.',
  PROCESSING_FAILED: `Processing of your request failed. Please try again shortly.`,
  PROCESSING_FAILED_LONG_RETRY: `Processing of your request failed. Please try again in a few minutes.`,
  DELETED_BY_PARTNER: 'Unfortunately, this ticket has been deleted by the partner',
  MULTIPLE_EDITORS: 'Multiple users are attempting to edit this record. Please refresh your page and try again.',
  DUPLICATE_COUPON_CODE: `The platform does not support multiple use coupon codes. Please remove duplicate coupon codes.`,
  TAKEN_BY_PARTNER: 'Unfortunately, this ticket has been taken by the partner',
  ACCESS_DENIED: "You don't have permissions to perform this action",
};

export const internalErrorMessageMap = {
  [SimplrErrors.Codes.TICKET_NOT_FOUND]: ERROR_MESSAGES.DELETED_BY_PARTNER,
  [SimplrErrors.Codes.LOCK_ERROR]: ERROR_MESSAGES.PROCESSING_FAILED,
  [SimplrErrors.Codes.MULTIPLE_EDITORS]: ERROR_MESSAGES.MULTIPLE_EDITORS,
  [SimplrErrors.Codes.DUPLICATE_COUPON_CODE]: ERROR_MESSAGES.DUPLICATE_COUPON_CODE,
  [SimplrErrors.Codes.TICKET_NOT_OPEN]: ERROR_MESSAGES.TAKEN_BY_PARTNER,
  [SimplrErrors.Codes.API_THROTTLING]: ERROR_MESSAGES.PROCESSING_FAILED_LONG_RETRY,
  [SimplrErrors.Codes.PERMISSION_ERROR]: ERROR_MESSAGES.ACCESS_DENIED,
};

/**
 * List of errors that can be ignored and not have them logged to Sentry.
 * This is passed as attributes to the Sentry initialization.
 * More reference on this url https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/#decluttering-sentry
 */
export const ignoreErrors = ['Session token is expired'];
